export default "__VITE_ASSET__ClY92sDY__"